import { Box } from "@mui/material";
import { Suspense, useState } from "react";
import { SubAppSkeleton } from "shell/components/SubAppSkeleton";
import { useTranslation } from "react-i18next";
import { Header } from "./components/Header";
import { MetricCards } from "./components/MetricCards";
import { ResourcesCard } from "./components/ResourcesCard";
import { ResourceTable } from "./components/ResourceTable";
export const HomeApp = () => {
  // Local Suspense boundary so lazy-loading the "dashboard" namespace shows a
  // fallback in the sub-app area only, instead of blanking the whole shell.
  return <Suspense fallback={<SubAppSkeleton />} data-sentry-element="Suspense" data-sentry-component="HomeApp" data-sentry-source-file="index.tsx">
      <Home data-sentry-element="Home" data-sentry-source-file="index.tsx" />
    </Suspense>;
};
const Home = () => {
  // Requesting the namespace here triggers its lazy load and suspends this
  // subtree until ready; child components use bare useTranslation() with
  // qualified keys (t("dashboard.key")) once it's in the store.
  useTranslation("dashboard");
  const [dateRange, setDateRange] = useState(30);
  return <Box sx={{
    color: "text.primary",
    backgroundColor: "grey.50",
    height: "100%",
    "*": {
      boxSizing: "border-box"
    }
  }} data-sentry-element="Box" data-sentry-component="Home" data-sentry-source-file="index.tsx">
      <Header dateRange={dateRange} onDateRangeChange={setDateRange} data-sentry-element="Header" data-sentry-source-file="index.tsx" />
      <Box sx={{
      mx: 3,
      mt: -7.5
    }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <Box sx={{
        mb: 2
      }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
          <MetricCards dateRange={dateRange} data-sentry-element="MetricCards" data-sentry-source-file="index.tsx" />
        </Box>
        <Box display="flex" gap={3} sx={{
        height: "calc(100vh - 286px)"
      }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
          <ResourceTable dateRange={dateRange} data-sentry-element="ResourceTable" data-sentry-source-file="index.tsx" />
          <Box sx={{
          minWidth: 327,
          maxWidth: 327,
          backgroundColor: "common.white",
          border: theme => `1px solid ${theme.palette.border}`,
          borderRadius: "8px",
          height: "fit-content"
        }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
            <ResourcesCard data-sentry-element="ResourcesCard" data-sentry-source-file="index.tsx" />
          </Box>
        </Box>
      </Box>
    </Box>;
};